import script from "./GridCompanyComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GridCompanyComponent.vue?vue&type=script&setup=true&lang=js"

import "./GridCompanyComponent.vue?vue&type=style&index=0&id=266836d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-266836d7"]])

export default __exports__